import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DataForCustomFormModel } from '@bo-client/activation-management/shared/models/actionWithMoreInfo.model';
import { GridRegistrationModel } from '@bo-client/activation-management/grid-registration/model/grid-registration.model';
import { FormGroup } from '@angular/forms';
import { CreateGridRegistrationFormsService } from '@bo-client/activation-management/grid-registration/create-grid-registration-forms.service';
import {
  GridRegistrationStatusEnum,
  GridRegistrationTypeEnum
} from '@bo-client/activation-management/grid-registration/model/grid-registration.enum';
import { CustomFormComponent } from '@bo-client/activation-management/custom-form.component';

@Component({
  selector: 'app-gr-plugin-custom-approve',
  templateUrl: './gr-plugin-custom-approve.component.html',
  styleUrls: ['./gr-plugin-custom-approve.component.scss']
})
export class GrPluginCustomApproveComponent
  implements
    CustomFormComponent<
      GridRegistrationModel,
      {
        pluginFeederNeedsMeterChange: boolean;
        additionalData: {
          withMeterChange: boolean;
        };
        comment: string;
      }
    >,
    OnInit
{
  @Input() data: DataForCustomFormModel<GridRegistrationModel>;
  @Output() onConfirm: EventEmitter<{
    pluginFeederNeedsMeterChange: boolean;
    additionalData: {
      withMeterChange: boolean;
    };
    comment: string;
  }> = new EventEmitter();

  public model: GridRegistrationModel;
  public currentForm: FormGroup;
  public comment = '';
  public approveAfterMeterChange = false;

  constructor(private createFormsGridRegistrationService: CreateGridRegistrationFormsService) {}

  ngOnInit(): void {
    this.model = this.data.model;
    this.currentForm = this.createFormsGridRegistrationService.createGridConnectionPointForm(
      this.data.model,
      1
    );
    this.approveAfterMeterChange =
      this.model.gridRegistrationType === GridRegistrationTypeEnum.PlugInProducer &&
      this.model.state === GridRegistrationStatusEnum.NeedMeterChange;
  }

  cancel() {
    this.onConfirm.emit(null);
  }

  confirm(withMeterChange: boolean) {
    this.onConfirm.emit({
      pluginFeederNeedsMeterChange: withMeterChange,
      additionalData: {
        withMeterChange: withMeterChange
      },
      comment: this.comment
    });
  }
}
